export class RegistrationResult {
    registrationId: string;
    fullName: string;
    emailAddress: string;
    phoneNumber: string;
    partyId: string;
    aboNumber: string;
  }
